import React from "react";
import ComingSoon from "components/admin/ComingSoon";

const AdminMembers: React.FC = () => (
  <ComingSoon
    icon="👥"
    title="회원 관리"
    features={[
      "회원 목록 조회 및 검색",
      "회원 상세 정보 · 이용 내역 확인",
      "계정 정지 · 강제 탈퇴 처리",
      "학과 · 학번 정보 관리",
      "회원 활동 통계",
    ]}
  />
);

export default AdminMembers;
